export default {"src":"/_next/static/media/warning-icon.d30de491.svg","height":36,"width":36};